import CriticalIcon from "@material-ui/icons/HighlightOff";
import WarningIcon from "@material-ui/icons/ErrorOutline";
import OkIcon from "@material-ui/icons/CheckCircleOutline";

export const getSeverityColorIcon = (reportSeverity, theme) => {
    const serverityColorMap = {
        "warning": theme.warning,
        "critical": theme.error,
        "ok": theme.active
    }
    const serverityIconMap = {
        "warning": WarningIcon,
        "critical": CriticalIcon,
        "ok": OkIcon
    }
    return { color: serverityColorMap[reportSeverity], icon: serverityIconMap[reportSeverity] }
}